{
	"name": "arcade",
	"roles": {
		"none": [0, 0, 0, 0],
		"outline": [26, 22, 30, 255],
		"white": [255, 255, 255, 255],

		"base": [116, 124, 140, 255],
		"base_lit": [158, 166, 182, 255],
		"base_shade": [80, 86, 102, 255],
		"base_dark": [50, 54, 68, 255],

		"accent": [232, 96, 72, 255],
		"accent_lit": [255, 148, 116, 255],
		"accent_dark": [166, 58, 48, 255],

		"metal": [140, 150, 166, 255],
		"metal_lit": [196, 204, 216, 255],
		"metal_dark": [88, 96, 112, 255],
		"rivet": [206, 212, 222, 255],

		"wood": [138, 96, 58, 255],
		"wood_lit": [176, 128, 82, 255],
		"wood_dark": [96, 64, 38, 255],

		"leaf": [92, 164, 74, 255],
		"leaf_lit": [138, 202, 102, 255],
		"leaf_dark": [56, 112, 54, 255],
		"stem": [102, 140, 66, 255],
		"soil": [88, 62, 44, 255],
		"soil_dark": [62, 44, 32, 255],
		"clay": [188, 106, 74, 255],
		"clay_lit": [220, 148, 112, 255],
		"clay_dark": [140, 74, 54, 255],

		"ceramic": [238, 236, 228, 255],
		"ceramic_shade": [200, 198, 190, 255],
		"ceramic_dark": [152, 150, 146, 255],

		"liquid": [124, 82, 52, 255],
		"liquid_lit": [166, 118, 78, 255],
		"liquid_dark": [86, 56, 36, 255],

		"glass": [200, 232, 240, 90],
		"good": [110, 200, 120, 255],
		"warn": [240, 190, 84, 255],
		"bad": [220, 78, 70, 255],
		"hot": [255, 186, 92, 255],
		"hot_lit": [255, 232, 158, 255],
		"chamber": [34, 32, 42, 255],
		"chamber_lit": [56, 54, 66, 255]
	},
	"ramps": {
		"fill": ["base_dark", "base", "base_lit"],
		"charge": ["bad", "warn", "good"],
		"heat": ["accent_dark", "accent", "hot", "hot_lit"],
		"growth": ["leaf_dark", "leaf", "leaf_lit"]
	}
}
